<template>
  <InvoiceRecognitionRegister />
</template>

<script>
export default {
    data() {
        return {
        }
    }
}
</script>
